import { render, staticRenderFns } from "./message.vue?vue&type=template&id=67e28b68&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&id=67e28b68&prod&lang=css&"
import style1 from "./message.vue?vue&type=style&index=1&id=67e28b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e28b68",
  null
  
)

export default component.exports